export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5159.56c00aa0.jpg";